<!-- チャットボットのタグ表示 -->
<!-- （編集モード(isEdit)で、追加・削除の処理を行う） -->

<template>
  <!-- タグ -->
  <div style="width: 100%;" v-if="!isLoading">
    <b-taglist class="tag-c">
      <template v-if="chatbotTagList.length > 0">
        <button class="button is-info is-small" style="margin-right: 5px; margin-top: 3px; display: block;" v-for="(tag, idx) in chatbotTagList" :key="idx + '-tag'">
          <span class="mdi" style="border-color: #000;"></span>
          {{tag}}
          <span v-if="isEdit" class="mdi mdi-close delete-tag-btn" name="delete-tag-btn" style="margin-left:5px;" @click="deleteTags(idx)"></span>
        </button>
      </template>
      <template v-else>
        <div style="margin-right: 10px;">タグ設定なし</div>
      </template>
      <template v-if="isEdit">
        <button class="button is-info is-small" @click="changeProcess" v-if="chatbotTagList.length < 3" style="margin-right: 5px; margin-top: 3px; display: block;">
          <span class="mdi mdi-plus" style="border-color: #000;"></span>
        </button>
      </template>
    </b-taglist>
    <b-taglist>
      <div v-if="isAdd">
        <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="addTag(tag)" v-for="(tag, idx) in sortedTags" :key="idx + '-tag'">
          <span class="mdi" style="border-color: #000;"></span>
          {{tag.name}}
        </button>
        <button v-if="isCreate===false" class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createTagOpen()">
          <span class="mdi" style="border-color: #000;"></span>
          ＋
        </button>
        <div class="tag-create" v-if="isCreate===true">
          <b-field>
            <p class="title">タグ名：</p><input class="input is-small" style="max-width: 95px;" maxlength="20" v-model="createTagName"/>
            <p class="title">説明：</p><input class="input is-small" style="max-width: 145px;" v-model="createTagDescription"/>
          </b-field>
          <b-field>
            <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createTag()">
              <p class="title">作成</p>
            </button>
            <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createTagCancel()">
              <p class="title">キャンセル</p>
            </button>
          </b-field>
        </div>
      </div>
    </b-taglist>
  </div>
  <div v-else>
    <span class="mdi mdi-loading mdi-spin"></span>作成中です
  </div>
</template>

<script>
import { mapState }    from 'vuex'

export default {
  props: {
    chatbot: {
      type: Object,
      required: false,
    },
    isEdit: {
      type: Boolean,
      required: false
    },
    isNew: {
      type: Boolean,
      required: true
    },
    isTemplate: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data () {
    return {
      isLoading: false,
      isAdd: false,
      isCreate: false,
      newRoboTagList: [],
      createTagName: '',
      createTagDescription: ''
    }
  },
  computed: {
    ...mapState('chatbot', ['chatbottags']),
    ...mapState('auth', ['user']),
    chatbotTagList () {
      let tags = []
      if (this.isNew) {
        for (const cb of this.newRoboTagList) {
          for (const tag of this.chatbottags) {
            if (cb.pk === tag.pk) {
              tags.push(tag.name)
              break
            }
          }
        }
      } else if(this.isTemplate){
        // テンプレートロボ一覧を表示する時はテンプレートロボが持っているタグをリスト化し、タグとして表示する
        tags = this.chatbot.chatbot_tag.map( tag => {return tag.name})
      } else {
        for (const cb of this.chatbot.tag) {
          for (const tag of this.chatbottags) {
            if (cb === tag.pk) {
              tags.push(tag.name)
              break
            }
          }
        }
      }
      tags = tags.slice().sort((x, y) => {return (x.name < y.name ? -1 : 1)})
      return this.$_.uniq(tags)
    },
    sortedTags () {
      return this.chatbottags.slice().sort((x, y) => {return (x.name < y.name ? -1 : 1)})
    }
  },
  methods: {
    changeProcess () {
      // 追加処理のON/OFF
      if (this.isAdd) {
        this.isAdd = false
      } else {
        this.isAdd = true
      }
    },

    // タグ追加
    addTag (tag) {
      this.isLoading = true

      if (this.isNew) {
        // 重複チェック
        if (this.newRoboTagList.find(addesTag => addesTag.name === tag.name)) {
          alert('既に登録されているタグです。')
          this.isLoading = false
          return
        }

        this.newRoboTagList.push(tag)

        if (this.newRoboTagList.length >= 3) {
          this.isAdd = false
        }

        this.$emit('changeTag', this.newRoboTagList)
      } else {
        // 重複チェック
        if (this.newRoboTagList.find(addesTag => addesTag.name === tag.name)) {
          alert('既に登録されているタグです。')
          this.isLoading = false
          return
        }

        this.chatbotTagList.push(tag.name)

        if (this.chatbotTagList.length >= 3) {
          this.isAdd = false
        }

        let tags = []
        for (const cb of this.chatbotTagList) {
          for (const tag of this.chatbottags) {
            if (cb === tag.name) {
              tags.push(tag.pk)
              break
            }
          }
        }

        this.chatbot.tag = tags
        this.$store.dispatch('chatbot/setChatBot', this.chatbot)
      }

      this.isLoading = false
    },

    //タグ削除
    deleteTags(i){
      this.isLoading = true

      if (this.isNew) {
        if (this.newRoboTagList.length === 1) {
          alert('タグは1つ以上設定する必要があります。\n別のタグを追加してから削除してください。')
          this.isLoading = false
          return
        }

        this.newRoboTagList.splice(i, 1)
        this.$emit('changeTag', this.newRoboTagList)
      } else {
        if (this.chatbotTagList.length === 1) {
          alert('タグは1つ以上設定する必要があります。\n別のタグを追加してから削除してください。')
          this.isLoading = false
          return
        }

        this.chatbotTagList.splice(i, 1)

        let taglist = []
        for (const cb of this.chatbotTagList) {
          for (const tag of this.chatbottags) {
            if (cb === tag.name) {
              taglist.push(tag.pk)
              break
            }
          }
        }

        this.chatbot.tag = taglist
        this.$store.dispatch('chatbot/setChatBot', this.chatbot)
      }

      this.isLoading = false
    },
    createTagOpen () {
      this.isCreate = true
      this.createTagName = ''
      this.createTagDescription = ''
    },
    createTagCancel () {
      this.isCreate = false
      this.createTagName = ''
      this.createTagDescription = ''
    },
    createTag () {
      this.$store.dispatch('chatbot/createChatBotTag', {
        name: this.createTagName,
        description: this.createTagDescription,
        company: this.user.companyPK,
      })
        .then (() => {
          this.isCreate = false
          this.createTagName = ''
          this.createTagDescription = ''
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-c {
  //flex-wrap: nowrap;
  overflow: hidden;
}
.tag-create {
  border: 1px solid;
  width: 100%;
  padding: 8px;
  .title {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/Common/Screen/organisms/ChatBotTags.vue